// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/svg/icon-hashtag.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon.icon-link{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");display:inline-block;width:20px;height:20px;background-size:20px 20px}.blog .nuxt-content{margin-top:-1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
